export default {
    getQueryBuiderTypes(state) {
        return state.types;
    },

    getQueryBuiderQueryParamters(state) {
        return state.queryParameters;
    },

    getColumnsRequiredInQueryBuilderReport(state){
        return state.columnsRequired;
    }
};
